<div id="eqPage" class="container iep-form-container">
  <mat-accordion>
    <mat-expansion-panel  class="md-expansion-demo-width" #step1 expanded="true">
      <mat-expansion-panel-header class="panel-header-background">
        <mat-panel-title>
          <h4 style="margin-bottom: 3px; margin-top: 5px; color: white;">Step 1: E/Q energy Benchmark Target Setting
          </h4>
        </mat-panel-title>

      </mat-expansion-panel-header>
      <div class="row pt-5"> 
        <!-- E/Q plan initial Step col-10 -->
        <div class="col-md-10 margin-bottom pt-3">
          <!-- Site List  -->
          <div class="row margin-radio">
            <div class="col-md-5 mt-5">
              <label>*Select Site Name:</label>
            <mat-form-field class="margin-4 ">
              <mat-label> </mat-label>
              <mat-select name="siteNameSelect" [(ngModel)]="selectSite" (selectionChange)="ChangeSite($event)" >
                <mat-option *ngFor="let site of sites" [value]="site.siteId">{{site.siteName}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          </div>

          <!-- E/Q plan radio buttons layout start -->
          <div class="col-md-6 pt-3">
            <mat-radio-group [(ngModel)]="planDateRadioGroup"> 
            <div class="row margin-radio mt-5 ml-5">
            
              <mat-radio-button name="dayRadio" id="eq-day"  #dayRadio value="dayRadio" (change)="dayChange($event)">Define E/Q plan for
                a day:</mat-radio-button>
            </div>
            <div class="row margin-radio mt-5 ml-5">
              <mat-radio-button name="planRadio" id="eq-month"  #montheq value="planmonth"  (change)="monthChange($event)">Define E/Q plan
                for a month:</mat-radio-button>
            </div>
          </mat-radio-group>

          </div>  <!-- E/Q plan radio buttons layout ends-->

          <!-- E/Q date and date range layout starts -->
          <div class="col-md-6  mt-3">

            <mat-form-field>
              <mat-label>Select Date</mat-label>
              <input matInput [matDatepicker]="picker3" [(ngModel)]="dateInputValue" (dateChange)="selectDate($event.value)"
                [disabled]="!dayChecked">
              <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
              <mat-datepicker #picker3></mat-datepicker>
            </mat-form-field>

            <mat-form-field>
              <mat-label>Select Date Range</mat-label>
              <mat-date-range-input [rangePicker]="picker" [(ngModel)]="monthInputValue"
                (dateChange)="dateChange($event.value)" [disabled]="!monthCkecked">
                <input matStartDate formControlName="start" placeholder="Start date">
                <input matEndDate formControlName="end" placeholder="End date">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>

          </div>  <!-- E/Q date and date range layout starts -->
        </div>   <!-- E/Q plan initial Step col-10 ends-->
      </div>  <!-- E/Q plan initial Step row ends -->
    

      <mat-divider></mat-divider>
       <!-- E/Q plan Second Step row -->
      <div class="row">
         <!-- E/Q plan load and value stream selection group layout of radio buttons and dropdowns -->
        <div class="col-md-2 pt-5 margin-left">
         <mat-radio-group [(ngModel)]="loadRadioGroup">
          <mat-radio-button name="loadName" id="load" class="mt-5" #load value="selectload"  (change)="loadChange($event)">Select Load:
          </mat-radio-button>

          <mat-form-field class="margin-4">
            <mat-label></mat-label>
            <mat-select name="loadsName" [(ngModel)]="loadnameList"  (selectionChange)="ChangeLoad($event)" [disabled]="!loadStatus">
              <mat-option  *ngFor="let load of loadsList" [value]="load.loadId">{{load.name}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-radio-button id="streamValue" class="mt-5" #streamValue value="streamValue"
          (change)="valueStreamChange($event)">Select Value Stream:</mat-radio-button>

          <mat-form-field class="margin-4">
            <mat-label></mat-label>
            <mat-select name="processName" [(ngModel)]="processnameList" (selectionChange)="changeStreamProcess($event)" [disabled]="!valueStreamStatus">
              <mat-option *ngFor="let process of processList" [value]="process.processId">{{process.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </mat-radio-group>
        </div>  <!-- radio button and drop down layout ends-->
       
        <!-- E/Q plan product name and Planed quantity table -->
        <div class="col-md-5 margin-left">
           <!-- Product Name Input field -->
         
          <label for="exampleInputEmail1">Product Name</label>
          <input type="text" [(ngModel)]="prdNameValue" (change)="dataSelect($event)" class="form-control mb-5" id="prdname" placeholder="Product Name" list="prdList">
          <datalist id="prdList"  *ngFor="let prd of productNameList">
            <option [value]="prd.name"></option>
          </datalist>
          <!-- Table Start  -->
          <div class="example-container mat-elevation-z8"
            [ngStyle]="{'height': datascrLeng === null  ? 'auto': datascrLeng <= 7 ? 'auto': '400px'}">
            <table matSort mat-table [dataSource]="dataSource">
              <caption>E/Q plan product name and Planed quantity table</caption>

              <!-- Load/Process Column -->
              <ng-container matColumnDef="load">
                <th scope="col" mat-header-cell *matHeaderCellDef class="table-color" mat-sort-header> Load/Process </th>
                <td mat-cell *matCellDef="let element"> {{element.load}} </td>
              </ng-container>

              <!-- Day of month Column -->
              <ng-container matColumnDef="daymonth">
                <th scope="col" mat-header-cell *matHeaderCellDef class="table-color" mat-sort-header> Day of Month </th>
                <td mat-cell *matCellDef="let element"> {{element.daymonth}} </td>
              </ng-container>

              <!-- Planned quantity Column -->
              <ng-container matColumnDef="quantity">
                <th scope="col" mat-header-cell *matHeaderCellDef class="table-color" mat-sort-header> Planned Quantity </th>
                <td mat-cell *matCellDef="let element; let i = index"> <input type="number" class=" mrgin-0" [id]="i" [(ngModel)]="plannedValue[i]" (keyup)="planedQuantityInput($event,i)" matInput placeholder="Enter Quantity"
                    [value]="element.quantity"></td>
              </ng-container>



              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="table-header"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
          </div> 
          <!-- table ends -->
        </div> <!-- E/Q plan product name and Planed quantity table ends-->
        
        <div class="col-md-5 margin-left">
         

         
          <!-- E/Q Load Trend -->
          <div class="row">
            <div class="col-md-7">
             <mat-radio-group [(ngModel)]="eqTrend">
              <mat-radio-button name="preValue" id="previousTrend" class="mt-5 margin-left" #previousValue value="streamValue" disabled="true">Load E/Q based on
                previous trend </mat-radio-button>

              <mat-radio-button name="newValue" id="newLoad" class="mt-5 margin-left" #streamValue  (change)="newLoadChange($event)"  value="newEq">Load new E/Q :
              </mat-radio-button>
            </mat-radio-group>
            </div>
            <div class="col-md-3">
              <input class="form-control ml-5 margin-left" type="number"  placeholder="20" disabled="true" [value]="defalutTrend">

              <input class="form-control ml-5 margin-left" type="number"  [(ngModel)]="newTrend" [disabled]="!newTrendSelect"  (keyup)= "newTrendValue($event)">
            </div>
            <div class="col-md-2 margin-left-unit">
              <div style="margin-top: 20px;">
                kWh/pc
              </div>
              <div style="margin-top: 27px;">
                kWh/pc
              </div>
            </div>
          </div>  <!-- E/Q Load Trend ends-->

        

          <!-- Check box -->

          <div class="row margin-left-checkbox ">
            <mat-checkbox class="" [(ngModel)]="proceedNextStep" (change)="proceedNextStepChange($event)">Use actual qty from machine live data</mat-checkbox>

          </div>

          <div class="row margin-left ">
            <button class="btn btn-primary btn-style mx-5 my-2" type="button" *ngIf="extendBtn" value="" (click)="copyPlanedQuantity()">Extend Planned Quantity</button>

          </div>


        </div>
      </div> <!-- E/Q plan Second Step row  ends --> 

      <!-- Submit buttons -->
      <div class="container">
        <div class="row">
          <div class="col text-center">
           
            <button class="btn btn-primary btn-style mx-5 my-2" type="reset" value="Clear"  (click)="clear()" >  Clear  </button>
            <button class="btn btn-primary btn-style mx-5 my-2" type="button" value="">Load Previous Value</button>
            <button class="btn btn-primary btn-style mx-5 my-2" type="submit" value="Submit" (click)="submitTrendSettings()">  Submit  </button>
          </div>
        </div>
      </div>

    </mat-expansion-panel>
  </mat-accordion>

  <!-- Step 2 -->
  <mat-accordion class="mt-3">
    <mat-expansion-panel class="md-expansion-demo-width mt-3" #step2 expanded="false" [disabled]="proceedNextStep">
      <mat-expansion-panel-header class="panel-header-background panel-heading">
        <mat-panel-title>
          <h4 style="margin-bottom: 3px; margin-top: 5px; color: white;">Step 2 : Click Here to Enter Actual Production
            Quantity Setting For Value Stream/ Machine E/Q Calculation</h4>
        </mat-panel-title>

      </mat-expansion-panel-header>



      <div class="row">

        <div class="col-md-5 margin-left">

          
          <mat-form-field>
            <mat-label>Select Date</mat-label>
            <input matInput [matDatepicker]="picker4" [(ngModel)]="liveDate"
              (dateChange)="getLoadByDateChangeLoad($event.value)">
            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
            <mat-datepicker #picker4></mat-datepicker>
          </mat-form-field>
        
          <mat-radio-group [(ngModel)]="loadStreamRadioGroup">
            <mat-radio-button name="loadName2" id="load2" class="mt-5" #loadval value="selectload2"  (change)="loadChangestep2($event)">Select Load:
            </mat-radio-button>
  
            <mat-form-field class="margin-4">
              <mat-label></mat-label>
              <mat-select name="loadsName" [(ngModel)]="load2nameList"  (selectionChange)="ChangeLoadStep2($event)" [disabled]="!load2Status">
                <mat-option  *ngFor="let load of loadsList" [value]="load.loadId">{{load.name}}</mat-option>
              </mat-select>
            </mat-form-field>
  
            <mat-radio-button id="streamValue2" class="mt-5" #streamValue2 value="streamValue2"
            (change)="valueStreamChangeStep2($event)">Select Value Stream:</mat-radio-button>
  
            <mat-form-field class="margin-4">
              <mat-label></mat-label>
              <mat-select name="processName2" [(ngModel)]="processnameList2" (selectionChange)="ChangeProcessStep2($event)" [disabled]="!value2StreamStatus">
                <mat-option *ngFor="let process of processList" [value]="process.processId">{{process.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </mat-radio-group>


        </div>
        <div class="col-md-7 margin-left">
            <div class="row shift-style">
                <div class="col-md-4">
                  Shift
                </div>
                <div class="col-md-4">
                  Enter Actual Qty
                </div>
                <div class="col-md-4">
                  Target Energy
                </div>
            </div>
            <div class="row shift-style" *ngFor="let shift of shiftNameList;let i">
              <div class="col-md-4"  style="margin-top: 10px;">
                {{shift.shiftName}}
              </div>
              <div class="col-md-4">
                <input type="number" class=" mrgin-0" [id]="shift.shiftId" [(ngModel)]="actualValue[shift.shiftId]" (keyup)="actualQuantityInput($event,shift.shiftName,shift.shiftId)" matInput placeholder="Enter Quantity"
                [value]="">
              </div>
              <div class="col-md-4">
                
              </div>
            </div>
        </div>
   
      </div>
      <div class="container">
        <div class="row">
          <div class="col text-center">
           
            <button class="btn btn-primary btn-style mx-5 my-2" type="reset" value="ClearStep2"  (click)="clearQuantitySettings()" >  Clear  </button>
            <button class="btn btn-primary btn-style mx-5 my-2" type="button" value="">Load Previous Value</button>
            <button class="btn btn-primary btn-style mx-5 my-2" type="submit" value="Submit" (click)="submitQuantitySettings()">  Submit  </button>
          </div>
        </div>
      </div>

    </mat-expansion-panel>
  </mat-accordion>

</div>